import React, { useCallback } from 'react';
import { HiOutlineChevronRight } from 'react-icons/hi';

export interface Props {
  showArrow?: boolean;
  onClickHandler?: () => void;
  size?: number;
}

const RightArrow = ({ showArrow, onClickHandler, size = 25 }: Props) => {
  const onClick = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      onClickHandler();
    },
    [onClickHandler],
  );
  return showArrow ? (
    <HiOutlineChevronRight
      className="!absolute cursor-pointer top-0 end-1 z-50 flex items-center h-full p-0 text-white rtl:rotate-180"
      onClick={onClick}
      size={size}
    />
  ) : null;
};

export default RightArrow;
